import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class RedtailIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    activateRedtailIntegration(username, integrationPassword) {
        // pragma: allowlist secret
        const url = this.urlsService.INTEGRATIONS.REDTAIL_INTEGRATION_AUTH;
        const postParams = {
            username,
            integrationPassword,
        };
        return this.ajaxService.postJsonDataObserveResponse(url, postParams);
    }
    deactivateRedtailIntegration() {
        const url = this.urlsService.INTEGRATIONS.REDTAIL_INTEGRATION_AUTH;
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getRedtailIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.REDTAIL_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getRedtailContactSearchResults(searchTerms, page) {
        const url = `${this.urlsService.INTEGRATIONS.REDTAIL_SEARCH}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getRedtailContactAccounts(contactId, page) {
        const urlParams = { contactId };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.REDTAIL_CONTACT_ACCOUNTS, urlParams)}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importRedtailHoldings(importType, postParams) {
        const urlParams = { importType };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.REDTAIL_IMPORT_HOLDINGS, urlParams)}`;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
RedtailIntegrationService.ɵfac = function RedtailIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RedtailIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
RedtailIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RedtailIntegrationService, factory: RedtailIntegrationService.ɵfac, providedIn: 'root' });
